window.addEventListener('alpine:init', () => {
  var { removeSectionWrapper, getDefaultAlpineMorphLifecycleHooks } = Alpine.store('utilities');

  var defaultAlpineMorphLifecycleHooks = getDefaultAlpineMorphLifecycleHooks();

  function productHistory(data = {}) {
    return {
      ...data,

      isLoadingProductHistory: false,

      onIntersect() {
        this.isLoadingProductHistory = true;

        var productHandles = [...JSON.parse(localStorage.getItem('product-history') || '[]')].filter((handle) => {
          return handle != this.productHandle;
        });

        if (!productHandles.length) return;

        var query = productHandles.map((handle) => `handle:"${handle}"`).join(' OR ');

        var url = new URL(`${location.origin}${window.global.routes.search_url}`);

        url.searchParams.set('type', 'product');
        url.searchParams.set('section_id', this.sectionId);
        url.searchParams.set('q', query);

        fetch(url)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            Alpine.morph(this.$root, sectionHtml, defaultAlpineMorphLifecycleHooks);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingProductHistory = false;
          });
      }
    };
  };

  Alpine.data('productHistory', productHistory);
});
